import { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { trackReturnVisit } from './analytics';

const AuthContext = createContext({ user: null, loading: true, signOut: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Detect email confirmation redirect (hash contains access_token or error)
    const hash = window.location.hash;
    if (hash && (hash.includes('access_token=') || hash.includes('error='))) {
      // This is an email confirmation landing — sign out so user must log in manually
      supabase.auth.signOut().then(() => {
        // Clear the hash and redirect to login
        window.location.replace('/login');
      });
      return;
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        const prev = user;
        setUser(session?.user ?? null);
        if (!prev && session?.user) {
          // User just logged in — check if return visit
          const lastVisit = localStorage.getItem('destrier_last_visit');
          if (lastVisit) trackReturnVisit();
          localStorage.setItem('destrier_last_visit', Date.now().toString());
        }
      }
    );

    return () => subscription.unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signOut = () => supabase.auth.signOut();

  return (
    <AuthContext.Provider value={{ user, loading, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
